module.exports = __webpack_public_path__ + "static/media/icon-cloud--purple.5ca331d3.svg";